import { CategoryPanelResponse } from 'models/category'

export const CategoriesResolver = {
    categories: () =>
        [
            {
                firm: {
                    professionalDisciplines: [
                        {
                            name: 'All Disciplines',
                            categories: [
                                {
                                    name: 'Administration',
                                    id: '123',
                                },
                            ],
                        },
                    ],
                },
            },
        ] as CategoryPanelResponse[],
}
